import { createElement, memo } from '@max/max';
import View from '@hfe/max-view';
import Text from '@hfe/max-text';
import Image from '@max/leez-image';
// import Icon from '@max/leez-icon';
import './index.scss';
import { WEICHAT_ICON } from '../../const';
import { BID_MAP, BID_TYPE } from '../../const/bid';
import Sensor from '@max/mbc-sensor';
const InviteButton = (props) => {
    const { onInvite, isMainState, onClose, onRefresh, lxReport } = props;
    const onChangeButton = () => {
        if (isMainState) {
            onRefresh?.();
            lxReport(BID_MAP.CHANGE_BATCH_BUTTON_CLICK, BID_TYPE.MC);
        }
        else {
            onClose?.();
            lxReport(BID_MAP.VIEW_VENUE_BUTTON_CLICK, BID_TYPE.MC);
        }
    };
    const onInviteClick = () => {
        onInvite?.();
        if (isMainState) {
            lxReport(BID_MAP.INVITE_FRIEND_BUTTON_CLICK, BID_TYPE.MC);
        }
        else {
            lxReport(BID_MAP.SYNC_FRIEND_BUTTON_CLICK, BID_TYPE.MC);
        }
    };
    return <Sensor onAppear={() => {
            if (isMainState) {
                lxReport(BID_MAP.CHANGE_BATCH_BUTTON_EXPOSURE, BID_TYPE.MV);
                lxReport(BID_MAP.INVITE_FRIEND_BUTTON_EXPOSURE, BID_TYPE.MV);
            }
            else {
                lxReport(BID_MAP.VIEW_VENUE_BUTTON_EXPOSURE, BID_TYPE.MV);
                lxReport(BID_MAP.SYNC_FRIEND_BUTTON_EXPOSURE, BID_TYPE.MV);
            }
        }}>
      <View className={"button-container"}>
        <View className="change-button" onClick={onChangeButton}>
          <Text className="change-text">{isMainState ? "换一批" : "查看会场"}</Text>
        </View>
        <View className="invite-button" onClick={onInviteClick}>
          <Image x-if={isMainState} source={{
            uri: WEICHAT_ICON
        }} style={{
            width: '36rpx',
            marginRight: '4rpx'
        }}></Image>
          <Text className="invite-button__text">{isMainState ? "邀请好友一起看" : "同步好友"}</Text>
        </View>
      </View>
    </Sensor>;
};
export default memo(InviteButton);
